/* istanbul ignore file */
import { get, isEmpty, isNil } from 'lodash';

export const extractImagineDocumentByInboxes = (
  claim: any,
  managerNotifcationsInboxes: any,
  selectedInboxeId: any,
  listings: any,
) => {
  const documentSagis = !isNil(get(claim, 'ListDocsIndexed', []))
    ? get(claim, 'ListDocsIndexed', [])
        .map((el: any) => ({
          ...el,
          documentTypeId: get(
            get(listings, 'documentTypes', []).find(
              (it: any) =>
                it.ItemDescription.toUpperCase() === el.DocumentType ||
                it.ItemDescription.toLowerCase() ===
                  el.DocumentType.toLowerCase(),
            ),
            'ItemKey',
            null,
          ),
          isIndexed: true,
        }))
        .filter((element: any) => !isNil(element.documentTypeId))
    : [];
  const notifType = get(listings, 'managerNotificationType', []).filter(
    (el: any) => el.managerInboxesId === selectedInboxeId,
  );
  const docTypeCorpo = notifType
    .map((el: any) => el.docTypeId)
    .filter((element: any) => !isNil(element));
  if (!isEmpty(documentSagis)) {
    return documentSagis.filter((item: any) =>
      docTypeCorpo.includes(String(item.documentTypeId)),
    );
  } else {
    return [];
  }
};

export const extractOtherImagineDocument = (
  claim: any,
  managerNotifcationsInboxes: any,
  docTypeInboxes: any,
  listings: any,
) => {
  const notifDocument = managerNotifcationsInboxes.map((el: any) =>
    get(el, 'documentImaging.documentImagingId'),
  );
  const docTypesSagis = get(claim, 'ListDocsIndexed', [])
    .filter((item: any) => !notifDocument.includes(item.DocumentID))
    .map((el: any) => ({
      ...el,
      documentTypeId: get(
        get(listings, 'documentTypes', []).find(
          (it: any) =>
            it.ItemDescription.toUpperCase() === el.DocumentType ||
            it.ItemDescription.toLowerCase() === el.DocumentType.toLowerCase(),
        ),
        'ItemKey',
        null,
      ),
      isIndexed: true,
    }));
  const docTypeCorpo = docTypeInboxes
    .map((el: any) => el.docTypeId)
    .filter((element: any) => !isNil(element));
  if (!isEmpty(docTypesSagis)) {
    const filtredDoc = docTypesSagis.filter(
      (item: any) =>
        !docTypeCorpo.includes(item.documentTypeId) ||
        isNil(item.documentTypeId),
    );
    return filtredDoc;
  } else {
    return [];
  }
};
export const extractImagineDocumentToImport = (
  claim: any,
  imagineTasks: any,
  listings: any,
) => {
  const docTypesSagis = get(claim, 'ListDocsIndexed', [])
    .filter((item: any) => item.indexedBy != 'CORPOREL_INDEXATION')
    .map((el: any) => ({
      ...el,
      documentTypeId: get(
        get(listings, 'documentTypes', []).find(
          (it: any) =>
            it.ItemDescription.toUpperCase() === el.DocumentType ||
            it.ItemDescription.toLowerCase() === el.DocumentType.toLowerCase(),
        ),
        'ItemKey',
        null,
      ),
      isIndexed: true,
    }));
  if (!isEmpty(imagineTasks)) {
    return docTypesSagis.filter((item: any) =>
      imagineTasks.includes(item.DocumentID),
    );
  } else {
    return [];
  }
};

export const filterDecidedImagineDocuments = (documents: any) => {
  return documents.filter(
    (el: any) =>
      isNil(get(el, 'documentImaging.documentImagingDecisionId', null)) &&
      isNil(get(el, 'treatedBy', null)),
  );
};

export const getDocTypeID = (listings: any, selectedInboxeId: any) => {
  return get(
    get(listings, 'managerNotificationType', []).find(
      (el: any) => el.managerInboxesId === selectedInboxeId,
    ),
    'docTypeId',
    null,
  );
};
